import Welcome from '../../../components/main/welcome';

export default Welcome;




// WEBPACK FOOTER //
// ./src/client/pages/main/welcome/index.js